import { execute } from './execute';
export const vm = {
    executeScripts: execute,
};
export { deserializeStackItem } from './stackItem';

//# sourceMappingURL=index.js.map
